const lang = {
  breadcrumb: {
    management: '配送拠点管理',
    list: '拠点一覧',
    create: '拠点追加',
    edit: '拠点編集',
    detail: '拠点詳細',
    import: '配送拠点取り込み',
  },
  steps: {
    search: '検索',
    select_center: '拠点を選択する',
    checking_content: '内容を確認する',
  },
  button: {
    import_center: '配送拠点を取り込む',
  },
  list: {
    paginate_text: '拠点一覧',
    current_search_criteria: '現在の検索条件',
    label: {
      created_at: '追加日時',
      updated_at: '変更日時',
    },
    button: {
      search: '検索条件変更',
    },
    placeholder: {
      created_at_start: '開始日',
    },
  },
  download: {
    page_title: 'データ取り込み',
    download_text: '1.入力用ファイル（csv）をダウンロードする',
    import_text: '2.配送拠点を入力し、取り込みファイルを選択する',
    btn_download: 'ダウンロード',
    btn_import: 'ファイル選択',
    file_name: 'ファイル名',
    note: '<div>※対応ファイル：csvファイル（.csv）</div><div>※最大ファイルサイズ：{max_file_size}MB</div>',
    error_message: 'ファイルにエラーがあります。もう一度確認してください。',
    input_file_name: '3月 東京拠点 配車実績',
  },
  confirm_import_modal: {
    text: '<p>ファイルを取り込んでもよろしいでしょうか？</p>',
    btn_cancel: 'キャンセル',
    btn_delete: '取り込む',
    required: '必須',
  },
  create: {
    page_title: '拠点を追加する',
    page_title_confirm: '拠点を追加する<span class="text-base">（確認）</span>',
    label: {
      name: '拠点名',
      code: '識別コード',
      group_code: 'グルーピング用コード',
      center_type: '拠点種別',
      owner_type: '拠点所有者タイプ',
      zip_code: '郵便番号',
      prefecture: '都道府県',
      city: '市区町村',
      house_number: '番地',
      building_name: '建物名・部屋番号',
      lat: '緯度',
      lng: '経度',
      label_lng: '度',
      name_center_berth: '名称',
      number_center_berth: '番号',
      note_center_berth: '備考',
      error_date_required: '日付を選択してください。',
      rep_name: '代表者 氏名',
      rep_last_name: '代表者 姓',
      rep_first_name: '代表者 名',
      rep_name_kana: '代表者 氏名（カナ）',
      rep_last_name_kana: '代表者 姓（カナ）',
      rep_first_name_kana: '代表者 名（カナ）',
      coverage_area: '対応エリア',
      phone_number: '電話番号',
      employee_num: '従業員数',
      employee_num_label: '名',
      imported_from: '登録倉庫事業者棟別リスト',
      open_price: '新規開設投資費用',
      open_price_label: '円',
      close_price: '閉鎖処理費用',
      close_price_label: '円',
      kotei_rent_price_month: '賃貸料',
      kotei_rent_price_month_label: '円',
      kotei_wage_price_month: '人件費',
      kotei_wage_price_month_label: '円',
      kotei_management_price_month: '管理費用',
      kotei_management_price_month_label: '円',
      manufacturing_price: '製造費',
      manufacturing_price_label: '円',
      stock_management_price: '在庫管理費',
      stock_management_price_label: '円',
      in_out_price: '入出庫費',
      in_out_price_label: '円',
      stock_volume: '在庫可能容積',
      out_volume_per_hour: '出荷能力/時間当り',
      out_volume_per_hour_label: '個/H',
      in_volume_per_hour: '入荷能力/時間当り',
      in_volume_per_hour_label: '個/H',
      note: '備考',
      title_berth_schedule: '顧客名',
      created_at: '追加日時',
      updated_at: '変更日時',
    },
    button: {
      confirm_input: '入力を確認する',
      to_add: '追加する',
    },
  },
  edit: {
    page_title: '拠点編集',
    page_title_confirm: '拠点編集<span class="text-base">（確認）</span>',
    message_confirm_delete: '拠点情報を削除してよろしいですか？<br>よろしければ「削除する」をクリックして下さい。',
    button: {
      delete: '削除する',
      update: '更新する',
    },
  },
  search: {
    title: '検索',
    label: {
      name: '拠点名',
      code: '識別コード',
      group_code: 'グルーピング用コード',
      center_type: '拠点種別',
      owner_type: '拠点所有者タイプ',
      zip_code: '郵便番号',
      prefecture: '都道府県',
      city: '市区町村',
      house_number: '番地',
      building_name: '建物名・部屋番号',
      lat: '緯度',
      lng: '経度',
      label_lng: '度',
      name_center_berth: '名称',
      number_center_berth: '番号',
      note_center_berth: '備考',
      error_date_required: '日付を選択してください。',
      rep_name: '代表者 氏名',
      rep_last_name: '代表者 姓',
      rep_first_name: '代表者 名',
      rep_name_kana: '代表者 氏名（カナ）',
      rep_last_name_kana: '代表者 姓（カナ）',
      rep_first_name_kana: '代表者 名（カナ）',
      coverage_area: '対応エリア',
      phone_number: '電話番号',
      employee_num: '従業員数',
      employee_num_label: '名',
      imported_from: '登録倉庫事業者棟別リスト',
      open_price: '新規開設投資費用',
      open_price_label: '円',
      close_price: '閉鎖処理費用',
      close_price_label: '円',
      kotei_rent_price_month: '賃貸料',
      kotei_rent_price_month_label: '円',
      kotei_wage_price_month: '人件費',
      kotei_wage_price_month_label: '円',
      kotei_management_price_month: '管理費用',
      kotei_management_price_month_label: '円',
      manufacturing_price: '製造費',
      manufacturing_price_label: '円',
      stock_management_price: '在庫管理費',
      stock_management_price_label: '円',
      in_out_price: '入出庫費',
      in_out_price_label: '円',
      stock_volume: '在庫可能容積',
      out_volume_per_hour: '出荷能力/時間当り',
      out_volume_per_hour_label: '個/H',
      in_volume_per_hour: '入荷能力/時間当り',
      in_volume_per_hour_label: '個/H',
      note: '備考',
      title_berth_schedule: '顧客名',
      created_at: '追加日時',
      updated_at: '変更日時',
    },
    placeholder: {
      please_select: '選択してください',
    },
    button: {
      confirm_input: '入力を確認する',
      add_center: '拠点を追加する',
      all_material: '全ての拠点を表示する',
      search: '検索する',
      add_center_berth: 'バース管理',
      center_berth_schedule: 'バーススケジュール',
      remove_center_berth: '行を削除する',
      add_dynamic_center_berth: '行を追加する',
      center_schedules: '稼働スケジュール',
      center_stocks: '在庫情報',
      center_network: '拠点ネットワーク',
      inventory_simulation: '在庫シミュレーション',
    },
  },
  detail: {
    page_title: '拠点詳細',
    to_edit: '編集する',
    page_title_center_berth_schedule: 'バーススケジュール',
  },
  record: {
    required: '※必須',
    required_message: '{attribute} は必須です。',
  },
  calender: {
    add_event_title: 'スケジュール追加',
    event_text: 'スケジュール',
    title_text: 'タイトル',
    repeats_text: '繰り返し',
    is_all_day_text: '終日',
    add_text: '追加',
    cancel_text: 'キャンセル',
    select_colors_text: '色選択',
    background_color_text: '背景',
    text_color_text: 'テキスト',
    border_color_text: '枠線',
    repeats_never: '繰り返さない',
    repeats_every_day_text: '毎日',
    repeats_every_week_text: '毎週',
    repeats_every2_weeks_text: '隔週',
    repeats_everymonth_text: '毎月',
    repeats_every_year_text: ' 毎年',
    repeat_options_title: '繰り返しオプション',
    repeat_days_to_exclude_text: '除外する曜日',
    day_names: ['月曜', '火曜', '水曜', '木曜', '金曜', '土曜', '日曜'],
    repeat_ends_text: '繰り返し終了日',
    optional_text: 'オプション',
    description_text: '備考',
    days_to_exclude_text: '除外する曜日',
    day_header_names: ['月', '火', '水', '木', '金', '土', '日'],
    edit_event_title: 'スケジュール編集',
    new_event_default_title: 'スケジュール名',
    from_text: '開始',
    to_text: '終了',
    update_text: '更新',
    custom_text: 'カスタム',
    location_text: '場所',
    group_text: 'グループ',
    url_text: 'URL',
    show_alert_text: 'アラートを表示',
    month_names: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    center_schedule_title: '稼働スケジュール',
  },
  stock: {
    list: {
      page_title: '在庫情報',
      search_label: 'フリーワード検索',
      button: {
        add: '在庫情報を追加する',
        edit: '編集する',
      },
      placeholder: {
        search: '明細番号、商品名、商品分類名',
      },
      label: {
        specification_code: '明細番号',
        several_order_code: '個別注文番号',
        stock_class_code: '在庫種別コード',
        seller_item_class_code: '受注者商品分類コード',
        item_class_name: '商品分類名',
        gtin: 'GTIN',
        industry_class_code: '業界固有コード分類',
        buyer_assign_item_code: '発注者品名コード',
        seller_assign_item_code: '受注者品名コード',
        warehouse_assign_item_code: '倉庫事業者品名コード',
        item_name: '商品名',
        short_item_name: '商品略号',
        standard: '規格',
        quality_class: '品質区分',
        item_quality_class_code: '良品不良品種別コード',
        temperature_class_code: '保管温度種別コード',
        reported_num: '個数（報告）',
        several_num_unit_code: '個別個数単位コード',
        item_weight: '商品重量',
        several_weight_code: '個別重量単位コード',
        content_measure_per_package: '内容入り数',
        reported_quantity: '数量（報告）',
        content_num_unit_code: '内容数量単位コード',
        content_num_per_package: '入り数',
        reported_bulk_num: 'バラ数（報告）',
        reported_bulk_num_unit: 'バラ単位コード',
        package_form_code: '荷姿コード',
        package_form_name_code: '荷姿名（漢字）',
        grai: 'GRAI',
        manufacture_date: '製造日',
        validity_term: '賞味期限／有効期限',
        reported_inlet_id: '入庫報告番号',
        inlet_date: '入庫日',
        storage_place_head_code: '保管場所コード（本社）',
        storage_place_branch_code: '保管場所コード（事業所）',
        estimated_departure_date_from: '出荷予定日（から）',
        estimated_departure_date_to: '出荷予定日（まで）',
        departure_date: '出荷日',
      },
    },
    create: {
      page_title: '在庫情報を追加する',
      button: {
        submit: '作成する',
      },
    },
    edit: {
      page_title: '在庫情報編集',
      button: {
        delete: '削除',
        submit: '更新する',
      },
    },
    modal_delete: {
      text: '商品名{name}の在庫情報を削除します。<br>よろしければ「削除する」をクリックして下さい。',
    },
  },
  network: {
    list: {
      page_title: '拠点ネットワーク',
      search_label: '拠点ネットワーク',
      button: {
        add: '拠点ネットワークを追加する',
        edit: '編集する',
      },
      placeholder: {
        search: '配送先 拠点名',
      },
      label: {
        center_network_id: 'ID',
        from_center_id: '配送元 拠点',
        to_center_id: '配送先 拠点',
        name: '名称',
        transport_mode: '輸送モード',
        transport_unit: '輸送ロット',
        transport_leadtime: '輸送リードタイム',
        transport_cost: '輸送コスト',
        transport_cur: '輸送コスト通貨',
        restrict_time: '制約',
        note: '備考',
      },
    },
    create: {
      page_title: '拠点ネットワーク',
      button: {
        submit: '作成する',
      },
    },
    edit: {
      page_title: '拠点ネットワーク',
      button: {
        delete: '削除',
        submit: '更新する',
      },
    },
    modal_delete: {
      text: '商品名{name}の在庫情報を削除します。<br>よろしければ「削除する」をクリックして下さい。',
    },
  },
  inventory: {
    page_title: '在庫情報編集',
    label: {
      scope: 'スコープ',
      term: '期間',
      stockout_rate: '欠品率',
      delivery_lead_time: 'リードタイム',
      inventory_turnover: '在庫回転率',
      waste_rate: '廃棄率',
    },
    unit: {
      percent: '％',
      day: '日',
    },
    placeholder: {
      term_start: '開始',
      term_end: '終了',
    },
    simulation_parameters: 'シミュレーションパラメータ',
    to_run: 'シミュレート実行',
    chart: {
      label: {
        shipping_quantity: '出荷量',
        ordering_quantity: '発注量',
        safety_stock: '安全在庫',
        proper_stock: '適正在庫',
        cycle_stock: 'サイクル在庫',
      },
    },
  },
  toast: {
    import_success: '配送拠点を取り込みました。',
  },
}

export default lang
